import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { forYou, notForYou } from '../data/kit';
export function AudienceSection() {
  return <section className="w-full bg-surface py-20 lg:py-28" aria-labelledby="para-quien" data-id="element-17" data-mp="mzoske42xenp">
      <div className="mx-auto max-w-6xl px-5" data-id="element-18" data-mp="s14b9zisb92x">
        <h2 id="para-quien" className="font-display text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl" data-id="element-19" data-mp="wzfkq9563hkm">
          ¿Para quién es este kit?
        </h2>

        <div className="mt-10 grid gap-8 lg:grid-cols-[1.4fr_1fr]" data-id="element-20" data-mp="3vj4kfi02tki4">
          <div className="rounded-3xl bg-brand-soft p-7 sm:p-9" data-id="element-21" data-mp="4c1t8qk8ne7w">
            <h3 className="font-display text-2xl font-black text-brand" data-id="element-22" data-mp="9ad5t91x42tt">Es para vos si…</h3>
            <ul className="mt-6 space-y-3.5" data-id="element-23" data-mp="e0tmd211c4ke">
              {forYou.map(item => <li key={item} className="flex gap-3 text-ink" data-id="element-24" data-mp="e2muymv7kyv1">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-25" data-mp="3cqaibonjxmvb">
                    <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-26" data-mp="3hntvel8ijtlo" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl bg-danger-soft p-7 sm:p-9" data-id="element-27" data-mp="zdsrcevjvxf5">
            <h3 className="font-display text-2xl font-black text-danger" data-id="element-28" data-mp="ujojzuidhndj">No es para vos si…</h3>
            <ul className="mt-6 space-y-3.5" data-id="element-29" data-mp="qimit84wb18x">
              {notForYou.map(item => <li key={item} className="flex gap-3 text-ink" data-id="element-30" data-mp="llckf2zj3f8y">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-danger" data-id="element-31" data-mp="gl83jbupkii7">
                    <XIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-32" data-mp="bllpx1ayx08v" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 grid gap-6 border-t border-line pt-10 md:grid-cols-3 md:items-end" data-id="element-33" data-mp="25z4u2tzi7h35">
          <div data-id="element-34" data-mp="21zm9jzblh80u">
            <p className="text-muted" data-id="element-35" data-mp="21zvxzigzr74f">No vendemos:</p>
            <p className="mt-1 font-display text-2xl font-black text-muted line-through decoration-danger decoration-[3px]" data-id="element-36" data-mp="3vhjvah1k29x6">
              “Hacete rico en 7 días.”
            </p>
          </div>
          <div data-id="element-37" data-mp="3mglltj8cla77">
            <p className="text-muted" data-id="element-38" data-mp="3mh55p5hk68nv">Te damos:</p>
            <p className="mt-1 font-display text-2xl font-black text-brand" data-id="element-39" data-mp="3mig7izrg16cc">
              Tres modelos + herramientas + planes de ejecución.
            </p>
          </div>
          <p className="text-lg text-ink" data-id="element-40" data-mp="i3ow3idpn156">El resultado depende de lo que hagas después.</p>
        </div>
      </div>
    </section>;
}